import axios from "axios";
import { toast } from "react-toastify";
import i18n from "../i18n";
import { logout } from "../services";
import {
  cleanupStorageForNewVersion,
  getStoredVersion,
  getToastDismissedFor,
  isHigherVersion,
  isMobileDevice,
  isOnLoginRoute,
  markToastDismissedFor,
  setStoredVersion,
} from "../utilities/appVersion";

let firstResponseProcessed = false;
let toastActive = false;
let loginReloadScheduled = false;

function handleVersionHeader(response) {
  const incoming =
    response?.headers?.["x-app-version"] || response?.headers?.["X-App-Version"];
  if (!incoming) return;

  const stored = getStoredVersion();

  if (!stored) {
    setStoredVersion(incoming);
    firstResponseProcessed = true;
    return;
  }

  if (!isHigherVersion(incoming, stored)) {
    firstResponseProcessed = true;
    return;
  }

  if (isOnLoginRoute()) {
    if (loginReloadScheduled) return;
    loginReloadScheduled = true;
    const updatingMessage = i18n.t("appUpdate.updating", {
      ns: "common",
      defaultValue: "Hay una nueva versión disponible. Actualizando la aplicación...",
    });
    toast.warning(updatingMessage, {
      autoClose: false,
      closeOnClick: false,
      draggable: false,
      closeButton: false,
    });
    setTimeout(() => {
      cleanupStorageForNewVersion(incoming);
      const hasToken = !!localStorage.getItem("token");
      window.location.replace(hasToken ? "/" : "/login");
    }, 3000);
    return;
  }

  if (loginReloadScheduled) return;

  if (!firstResponseProcessed) {
    cleanupStorageForNewVersion(incoming);
    firstResponseProcessed = true;
    return;
  }

  if (getToastDismissedFor() === incoming || toastActive) return;

  toastActive = true;
  const isMobile = isMobileDevice();
  const message = i18n.t(
    isMobile ? "appUpdate.newVersionMobile" : "appUpdate.newVersion",
    {
      ns: "common",
      defaultValue: isMobile
        ? "Nueva versión disponible, te recomendamos cerrar sesión y actualizar la página para estar en la última versión."
        : "Nueva versión disponible, te recomendamos cerrar sesión y pulsar CTRL + SHIFT + R para estar en la última versión.",
    }
  );
  toast.warning(message, {
    autoClose: false,
    closeOnClick: false,
    draggable: false,
    onClose: () => {
      toastActive = false;
      markToastDismissedFor(incoming);
    },
  });
}

// https://api.laefincas.grupolae.net/api/

// axios.defaults.baseURL = "http://localhost:4001/api/";
axios.defaults.baseURL = process.env.REACT_APP_API_URL;
// const URL_DEV = "https://apifincasdev.azurewebsites.net/api/";
// axios.defaults.baseURL = URL_DEV;
export const AxiosInterceptor = () => {
  

  const updateHeader = (request) => {
    const token = localStorage.getItem("token");
    const language = localStorage.getItem("i18nextLng") ?? "es";
    const newHeaders = {
      ...request.headers,
      provide: "laefincas",
      "Accept-Language": language,
    };

    if (token) {
      newHeaders.Authorization = `Bearer ${token}`;
    }

    request.headers = newHeaders;

    return request;
  };

  axios.interceptors.request.use((request) => {
    if (request.url?.includes("assets")) return request;
    return updateHeader(request);
  });

  axios.interceptors.response.use(
    (response) => {
      handleVersionHeader(response);
      return response;
    },
    (error) => {
      console.log("error", error);
      // Error de red (sin respuesta del servidor): error.response es undefined.
      // Hay que salir ANTES de leer error.response.status, o se lanza un TypeError
      // que rompe el propio manejador de errores en cada caída de conexión.
      if (!error?.response) {
        return Promise.reject(error);
      }
      handleVersionHeader(error.response);
      // toast.error(
      //   getValidationError(error.code) + " " + JSON.stringify(error.response.data)
      // );
      // console.log(getValidationError(error.code) + " " + JSON.stringify(error.response.data))
      if(error.response.status === 403){
        return error.response;
      }
      if(error.response.status === 500){
        return error.response;
      }
      // Unauthorized
      if (error.response &&  error.response.status === 401) {

        if (error.config?.headers?.Authorization) {
          logout();
        }
        return error.response;
      }
      return Promise.reject(error.response);
    }
  );
};
